import { ReactNode } from 'react';
import {
  QueryClientProvider as ReactQueryClientProvider,
  QueryClient,
  QueryCache,
  MutationCache,
} from '@tanstack/react-query';
import API from 'api/API';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 5 minutes
    },
  },
  queryCache: new QueryCache({
    // enables global error handling
    onError(error, query) {
      if (!query.meta?.ignoreGlobalError) {
        API.errorHandler(error);
      }
    },
  }),
  mutationCache: new MutationCache({
    // enables global error handling
    onError(error, _variables, _context, mutation) {
      if (!mutation.meta?.ignoreGlobalError) {
        API.errorHandler(error);
      }
    },
  }),
});

type Props = {
  children?: ReactNode;
};

export const QueryClientProvider = ({ children }: Props) => {
  return <ReactQueryClientProvider client={queryClient}>{children}</ReactQueryClientProvider>;
};
